module.exports = __webpack_public_path__ + "img/catalog.6aaca36b.png";